import React from 'react';
import Countdown from 'react-countdown-now';

function ExpirationTimer({ endDate }) {
  const now = new Date();
  const expirationDate = new Date(endDate);
  const diffMilliseconds = expirationDate - now;

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed || diffMilliseconds <= 0) {
      return <span>Expired</span>;
    } else if (diffMilliseconds <= 24 * 60 * 60 * 1000) {
      return (
        <span>
          {`Expires: ${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}
        </span>
      );
    } else if (diffMilliseconds <= 7 * 24 * 60 * 60 * 1000) {
      return <span>{`Expires: ${days} days ${hours} hours`}</span>;
    } else {
      return <span></span>;
    }
  };

  return <Countdown date={expirationDate} renderer={renderer} />;
}

export default ExpirationTimer;
